export default {
  feedInfo: [
    {
      key: "feedUrl",
      title: "地址",
      type: "link",
    },
    {
      key: "title",
      title: "标题",
    },
    {
      key: "description",
      title: "描述",
    },
    {
      key: "author",
      title: "作者",
    },
    {
      key: "pubDate",
      title: "发布时间",
      type: "date",
    },
    {
      key: "icon",
      title: "图标",
      type: "link",
    },
    {
      key: "link",
      title: "相关链接",
      type: "link",
    },
    {
      key: "webMaster",
      title: "网站管理员",
    },
    {
      key: "managingEditor",
      title: "主编",
    },
    {
      key: "generator",
      title: "生成器",
    },
    {
      key: "language",
      title: "语言",
    },
    {
      key: "lastBuildDate",
      title: "上次构建时间",
      type: "date",
    },
  ],
  itemInfo: [
    {
      key: "link",
      title: "原文地址",
      type: "link",
    },
    {
      key: "pubDate",
      title: "发布时间",
      type: "date",
    },
    {
      key: "receivedDate",
      title: "接收时间",
      type: "date",
    },
  ],
};
